import type { Plan } from "../redux/api";

// What a plan includes, for the Subscription screen. Ported from
// mobileapp/src/utils/planLimits.ts.
//
// A limit of 0 (or absent) means UNLIMITED, not "none" — assertWithinPlanLimit
// returns early on a falsy limit and never blocks.

export interface PlanLimitRow {
  id: string;
  label: string;
  /** null means unlimited. */
  value: number | null;
  suffix?: string;
}

export const isNegotiatedPlan = (plan: Plan): boolean =>
  (plan.code ?? "").toUpperCase() === "CUSTOM";

const cap = (n?: number | null): number | null => (!n ? null : n);

export const planLimitRows = (plan: Plan): PlanLimitRow[] => {
  // assertWithinPlanLimit skips CUSTOM before reading any limit, so stored
  // numbers on a negotiated plan are never applied — show them as unlimited.
  const negotiated = isNegotiatedPlan(plan);
  const value = (n?: number | null) => (negotiated ? null : cap(n));

  return [
    { id: "users", label: "Team members", value: value(plan.limits?.users) },
    { id: "products", label: "Products", value: value(plan.limits?.products) },
    {
      id: "storage",
      label: "Storage",
      value: value(plan.limits?.storageGB),
      suffix: "GB",
    },
    {
      id: "api",
      label: "API calls / month",
      value: value(plan.limits?.apiCallsPerMonth),
    },
  ];
};

export const planLimitValueLabel = (row: PlanLimitRow): string =>
  row.value === null
    ? "Unlimited"
    : `${row.value.toLocaleString()}${row.suffix ? ` ${row.suffix}` : ""}`;
